import { render, staticRenderFns } from "./BranchMenuList.vue?vue&type=template&id=5703bdec&"
import script from "./BranchMenuList.vue?vue&type=script&lang=js&"
export * from "./BranchMenuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports